var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9167 48.125L30.4792 33.6875C29.3333 34.6042 28.0156 35.3299 26.526 35.8646C25.0365 36.3993 23.4514 36.6667 21.7708 36.6667C17.6076 36.6667 14.0842 35.2248 11.2005 32.3411C8.31684 29.4575 6.875 25.934 6.875 21.7708C6.875 17.6076 8.31684 14.0842 11.2005 11.2005C14.0842 8.31684 17.6076 6.875 21.7708 6.875C25.934 6.875 29.4575 8.31684 32.3411 11.2005C35.2248 14.0842 36.6667 17.6076 36.6667 21.7708C36.6667 23.4514 36.3993 25.0365 35.8646 26.526C35.3299 28.0156 34.6042 29.3333 33.6875 30.4792L48.125 44.9167L44.9167 48.125ZM21.7708 32.0833C24.6354 32.0833 27.0703 31.0807 29.0755 29.0755C31.0807 27.0703 32.0833 24.6354 32.0833 21.7708C32.0833 18.9062 31.0807 16.4714 29.0755 14.4661C27.0703 12.4609 24.6354 11.4583 21.7708 11.4583C18.9062 11.4583 16.4714 12.4609 14.4661 14.4661C12.4609 16.4714 11.4583 18.9062 11.4583 21.7708C11.4583 24.6354 12.4609 27.0703 14.4661 29.0755C16.4714 31.0807 18.9062 32.0833 21.7708 32.0833Z",
    fill: "#3D3D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.967afbdc6bc23ddd1ca18817b7a527b2.svg";
export { ForwardRef as ReactComponent };